import {RankedModeTypes} from '../../../../shared/GameEnums'
import {LeaderboardConstants} from '../../../../shared/leaderboard_data/LeaderboardConstants'
import {UILeaderboardSidebarTabsController} from './UILeaderboardSidebarTabsController'
import {UIWLeaderboardController} from './UIWLeaderboardController'
import {UIDLeaderboardCTAController} from './UIDLeaderboardCTAController'
import {UIDLeaderboardStickyRowController} from './UIDLeaderboardStickyRowController'
import {UIDLeaderboardTableController} from './UIDLeaderboardTableController'
import {UILeaderboardHorizontalTabsController} from './UILeaderboardHorizontalTabsController'
import {ViewPopup} from '../../../shared/scripts/ui_popup/ViewPopup'
import {UIProfileSettingsRegionChangeController} from '../../../shared/scripts/profile/UIProfileSettingsRegionChangeController'
import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {UIComponentSearchController} from '../../../shared/scripts/ui_components/UIComponentSearchController'

export class UIDLeaderboardController extends UIWLeaderboardController {
    protected init() {
        UIWLeaderboardController.featureCheck()
        this.stickyRowController = new UIDLeaderboardStickyRowController()
        this.tableController = new UIDLeaderboardTableController(() => this.fetchScrollData(), this.stickyRowController)
        this.tabsController = new UILeaderboardHorizontalTabsController((leaderboardUrl: string) => this.onHorizontalTabChange(leaderboardUrl))
        this.sidebarTabsController = new UILeaderboardSidebarTabsController((rankedMode: RankedModeTypes) => this.onRankedModeChange(rankedMode))
        this.highlightRowElement = document.querySelector('.leaderboard_highlight_row') as HTMLDivElement
        this.ctaController = new UIDLeaderboardCTAController()

        this.initiateParametersFromUrl()
        void this.fetchNewTabs()
        void this.fetchMyStickyRowData()

        this.searchController = new UIComponentSearchController('leaderboard_search', this.searchTerm, (searchValue: string) => this.onSearchChange(searchValue))
        this.switchRankingCategoryTypeData(this.rankedModeType, this.leaderboardUrl, this.searchTerm, false)
    }

    async fetchStickyRowData() {
        void this.fetchMyStickyRowData()
    }

    protected override async onRankedModeChange(rankedMode: RankedModeTypes) {
        this.switchRankingCategoryTypeData(rankedMode, this.leaderboardUrl, this.searchTerm)
        await this.fetchMyStickyRowData()
        this.showChangeRegionIncentivePopup()
    }

    protected override initiateParametersFromUrl() {
        this.leaderboardUrl = LeaderboardConstants.globalLeaderboardUrl
        this.searchTerm = ''
    }

    protected switchRankingCategoryTypeData(mode: RankedModeTypes, regionId: string, search: string, push: boolean = true) {
        this.rankedModeType = mode
        this.leaderboardUrl = regionId
        this.searchTerm = search

        this.sidebarTabsController.highlightTab(this.rankedModeType)
        this.tabsController.highlightTab(this.leaderboardUrl)
        this.tableController.clearData()
        this.tableController.scrollToTop()
        this.searchTerm == LeaderboardConstants.emptyUsernameSearch ? void this.fetchScrollData() : void this.fetchSearchData()
    }

    showChangeRegionIncentivePopup() {
        const alreadyShown = StorageWrapper.getDiscordChangeRegionIncentivePopupShown()
        if(alreadyShown) return

        const isRanked = (this.stickyRowController as UIDLeaderboardStickyRowController).isRanked
        if(!isRanked) return

        const changedRegionManually = ClientUserState.userState?.regionUpdated != undefined
        if(changedRegionManually) return

        const popup = new ViewPopup({key: 'strings:popups.changeRegionIncentive.title'},
            {key: 'strings:popups.changeRegionIncentive.body'},
            () => UIProfileSettingsRegionChangeController.showChangeRegionPopup(),
            () => undefined,
            true)
        popup.removeXButton()
        popup.show()
        StorageWrapper.setDiscordChangeRegionIncentivePopupShown()
    }
}
